import { useId } from "react";

import { cn } from "@/lib/utils";

export function CloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.95 4.95l9.899 9.9m-.001-9.9l-9.9 9.9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function LocationIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-dark-raspberry", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.114 8.057c0 4.405-6.057 9.843-6.057 9.843S4 12.462 4 8.057a6.057 6.057 0 1112.114 0z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="10.056"
        cy="7.979"
        fill="none"
        r="2.208"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function ShareIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-4.5", className)}
      fill="none"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        height="10.447"
        rx="3.265"
        stroke={`url(#${id}-a)`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="rotate(45 7.715 5.67)"
        width="6.529"
        x="7.715"
        y="5.669"
      />
      <rect
        height="10.447"
        rx="3.265"
        stroke={`url(#${id}-b)`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        transform="rotate(45 13.055 .327)"
        width="6.529"
        x="13.055"
        y="0.327"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-a`}
          x1="9.347"
          x2="4.652"
          y1="8.281"
          y2="11.216"
        >
          <stop stopColor="#bd2885" />
          <stop offset="1" stopColor="#90278e" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}-b`}
          x1="14.687"
          x2="9.992"
          y1="2.939"
          y2="5.873"
        >
          <stop stopColor="#bd2885" />
          <stop offset="1" stopColor="#90278e" />
        </linearGradient>
      </defs>
    </svg>
  );
}
